__turbopack_context__.v({
  "container": "auth-buttons-module__4vGUCW__container",
  "light": "auth-buttons-module__4vGUCW__light",
  "logoutButton": "auth-buttons-module__4vGUCW__logoutButton",
  "signInButton": "auth-buttons-module__4vGUCW__signInButton",
  "userEmail": "auth-buttons-module__4vGUCW__userEmail",
  "userInfo": "auth-buttons-module__4vGUCW__userInfo",
  "userName": "auth-buttons-module__4vGUCW__userName",
});
